import { useCallback, useMemo } from 'react'

import { useQueryParams } from '../../../hooks/useQueryParams'

type UseScoutConnectionIdResponse = {
  scoutConnectionId?: string | null
  setScoutConnectionId: (scoutConnectionId: string | null) => void
  error?: string | null
  clearError: () => void
}

export const useScoutConnectionId = (): UseScoutConnectionIdResponse => {
  const [queryParams, setQueryParams] = useQueryParams<{ scoutConnectionId?: string | null; error?: string | null }>({
    enabled: true,
    defaultQuery: { scoutConnectionId: null, error: null },
  })

  const scoutConnectionId = queryParams.scoutConnectionId
  const error = queryParams.error
  const setScoutConnectionId = useCallback(
    (scoutConnectionId: string | null) => {
      setQueryParams({ scoutConnectionId })
    },
    [setQueryParams],
  )

  const clearError = useCallback(() => {
    setQueryParams({ error: null })
  }, [setQueryParams])

  return useMemo(() => {
    return { scoutConnectionId, setScoutConnectionId, error, clearError }
  }, [scoutConnectionId, setScoutConnectionId, error, clearError])
}
